export default __webpack_public_path__ + "static/exit_light_b.9262fda445e46b6471a8f1d6b39a74cb.svg";